module.exports = __webpack_public_path__ + "static/scanme_qr_group_es-fdff5652eb637fa957502254cbae85cf.png";